export async function prepareUnsponsoredOp(args) {
    const { smartAccount, callData } = args;
    if (!smartAccount.client.account) {
        throw new Error('Smart account client account is undefined');
    }
    return smartAccount.prepareUserOperation({
        account: smartAccount.client.account,
        callData,
        // these parameters are part of what the viem prepareUserOperation uses to fill in missing props on the passed in op
        // these are the default parameters, but with `paymaster` omitted
        // because we're not using a paymaster for this op
        parameters: ['factory', 'fees', 'gas', 'nonce', 'signature'],
    });
}
